import type { RouteRecordRaw } from 'vue-router';
import type { CustomRouteLocation, CustomRouteLocationRaw } from './types';
import type { Event } from '@patsnap/tahiti-core';

export const RouterProxy = Symbol.for('RouterProxy');

export interface RouterProxy {
    readonly onRouteChange: Event<CustomRouteLocation>;
    readonly currentRoute: CustomRouteLocation;
    install: () => { routes: RouteRecordRaw[], defaultRoute: RouteRecordRaw };
    push: (to: CustomRouteLocationRaw) => Promise<void>;
}
